import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';

import { absoluteRoutePaths } from 'app/core/routing';
import { selectIsApiConfigValidIfLoaded } from 'app/state/api-config/api-config.selectors';

export const apiConfigToBeSetGuardFn: CanActivateFn = () => {
    const store = inject(Store);
    const router = inject(Router);
    return store.pipe(
        selectIsApiConfigValidIfLoaded,
        map((isApiConfigValid) => (isApiConfigValid ? router.parseUrl(absoluteRoutePaths.home) : true)),
    );
};
